import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @param {Array.<function>} conditions
 *
 * @returns {Promise<?string>}
 */
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(conditions) {
    var index, condition, conditionMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < conditions.length)) {
              _context.next = 11;
              break;
            }

            condition = conditions[index]; // eslint-disable-next-line no-await-in-loop

            _context.next = 5;
            return condition();

          case 5:
            conditionMessage = _context.sent;

            if (!(conditionMessage !== null)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", conditionMessage);

          case 8:
            index++;
            _context.next = 1;
            break;

          case 11:
            return _context.abrupt("return", null);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();